import {createContext, useContext} from 'react';

interface Context {
    docReady: boolean;
}
const RepositoryContext = createContext<Context>({
    docReady: true,
});

const useRepositoryContext = () => useContext(RepositoryContext);

export {
    RepositoryContext,
    useRepositoryContext,
};
